<div class="limit" style="margin-bottom: 8px">
  <p class="limit-text">{{'POLL-CREATION.VOTERS.PLURINOMINAL-MIN' | translate}}</p>
  <textarea type="text" name="limit-voters-election" class="limit-voters" id="pluri-min-{{index}}"
            (focusout)="onVotersDone()" (keyup)="onVotersChanges($event)">{{numberOfVote}}</textarea>
</div>
